import { Typography, Box } from '@mui/material';
import LimitTransactionModal from 'components/LimitTransactionModal';
import FormStep3Section1Container from 'containers/FormStep3Section1Container';
import FormStep3Section2Container from 'containers/FormStep3Section2Container';
import { t } from 'i18next';
import { useState } from 'react';

export default function WrapperForm3Section1to2() {
  const [isLimitModalOpen, setIsLimitModalOpen] = useState(false);

  return (
    <>
      <Typography color="surface.700" variant="h6" sx={{ mb: 1 }}>
        {t('step3.t&cTitle')}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography color="surface.900" fontWeight="500" variant="body2" sx={{ lineHeight: 1.7 }}>
          Bertindak mewakili perusahaan, menunjuk PIC pengisian form digital
        </Typography>
      </Box>
      <FormStep3Section1Container />
      <FormStep3Section2Container />
      <LimitTransactionModal open={isLimitModalOpen} onClose={setIsLimitModalOpen} />
    </>
  );
}
